import { createFileRoute } from "@tanstack/react-router";
import { TreatmentSectorsSystemEditor } from "@/components/field/setup/TreatmentSectors";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/treatment-sectors/$irrigationSystemId",
)({
    component: TreatmentSectorsSystemEditorPane,
});

function TreatmentSectorsSystemEditorPane() {
    const { irrigationSystemId } = Route.useParams();
    return (
        <TreatmentSectorsSystemEditor
            irrigationSystemId={irrigationSystemId}
        />
    );
}
